import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from '@mui/material/InputAdornment';

const PlateForm = () => {
  const { 
    plateName, setPlateName, formErrors 
  } = useContext(MaterialsCaptureContext);

  return(
    <Box 
      sx={{
        mt: 2,
        mb: 1,
        width: '70%',
        minWidth: 600,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        mx: 'auto'
      }}
    >
      <TextField
        variant="outlined"
        label="Enter Plate Name"
        name={'plate_name'}
        value={plateName}
        onChange={e => 
          setPlateName(e.target.value)
        }
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">LNP_</InputAdornment>
          ),
        }}
        helperText={formErrors['plate_name']}
        error={'plate_name' in formErrors}
        type='number'
        fullWidth
      />
    </Box>
  );
};

export default PlateForm;